import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-private-classes */
import styled from 'styled-components';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
const LoadingSpinnerContainer = styled.div.withConfig({
  displayName: "LoadingModal__LoadingSpinnerContainer",
  componentId: "sc-1s0hz7m-0"
})(["height:420px;"]);
const LoadingContentContainer = styled.div.withConfig({
  displayName: "LoadingModal__LoadingContentContainer",
  componentId: "sc-1s0hz7m-1"
})(["height:500px;position:relative;"]);
const ModalContent = styled.div.withConfig({
  displayName: "LoadingModal__ModalContent",
  componentId: "sc-1s0hz7m-2"
})(["height:", ";width:", ";"], ({
  height
}) => height, ({
  width
}) => width);
/* stylelint-disable hubspot-dev/no-private-classes */

const StyledLoadingModal = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, ["showParentModal"]);

  return /*#__PURE__*/_jsx(UIModal, Object.assign({}, rest));
}).withConfig({
  displayName: "LoadingModal__StyledLoadingModal",
  componentId: "sc-1s0hz7m-3"
})(["&&& .private-modal{background-color:", ";}"], ({
  showParentModal
}) => showParentModal ? undefined : 'transparent');
export const LoadingModal = ({
  frameReady,
  children,
  modalWidth,
  modalHeight,
  modalUse,
  showParentModal,
  wrapContentSize
}) => {
  const readyContent = wrapContentSize ? /*#__PURE__*/_jsx(ModalContent, {
    width: modalWidth,
    height: modalHeight,
    children: children
  }) : children;
  return /*#__PURE__*/_jsx(StyledLoadingModal, {
    width: modalWidth,
    use: modalUse,
    "data-test-id": "upgrade-loading-modal",
    showParentModal: showParentModal,
    children: frameReady ? readyContent : /*#__PURE__*/_jsxs(LoadingContentContainer, {
      children: [/*#__PURE__*/_jsx(UIAbstractProgress, {
        autoStart: true,
        render: ({
          value
        }) => /*#__PURE__*/_jsx(UINanoProgress, {
          value: value,
          animateOnComplete: true
        })
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(LoadingSpinnerContainer, {
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "small",
            grow: true
          })
        })
      })]
    })
  });
};
LoadingModal.defaultProps = {
  modalWidth: 900,
  modalHeight: 500,
  modalUse: 'conversational',
  showParentModal: true,
  wrapContentSize: true
};